'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dStorage$002dFormat$0024 from "./app.data.-App-Document-Storage-Format$.js";
import * as $j_app$002edata$002e$002dImmu$002dD$002dB$002dData$002dCenter$002dId$0024 from "./app.data.-Immu-D-B-Data-Center-Id$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentId(dcId, storageFormat, docId) {
  this.XF = null;
  this.XH = null;
  this.XG = null;
  this.ayW = null;
  this.ayX = false;
  this.XF = dcId;
  this.XH = storageFormat;
  this.XG = docId;
}
export { $c_Lapp_data_AppDocumentId as $c_Lapp_data_AppDocumentId };
$p = $c_Lapp_data_AppDocumentId.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentId;
/** @constructor */
function $h_Lapp_data_AppDocumentId() {
}
export { $h_Lapp_data_AppDocumentId as $h_Lapp_data_AppDocumentId };
$h_Lapp_data_AppDocumentId.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentId)) {
    var x = this.XF;
    var x$2 = x$0.XF;
    if ((x === x$2)) {
      var x$3 = this.XH;
      var x$4 = x$0.XH;
      var $x_1 = (x$3 === x$4);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.XG;
      var x$6 = x$0.XG;
      return ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 3;
});
$p.t = (function() {
  return "AppDocumentId";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.XF;
      break;
    }
    case 1: {
      return this.XH;
      break;
    }
    case 2: {
      return this.XG;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "dcId";
      break;
    }
    case 1: {
      return "storageFormat";
      break;
    }
    case 2: {
      return "docId";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.ue = (function() {
  if ((!this.ayX)) {
    this.ayW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_Show$ShowInterpolator$().b5(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_StringContext($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().d(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.r().C)(["", "-", "-", ""]))), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().m(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcats_Show$Shown.r().C)([new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$Shown($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_Show$Shown$().aH(this.XF, $j_app$002edata$002e$002dImmu$002dD$002dB$002dData$002dCenter$002dId$0024.$m_Lapp_data_ImmuDBDataCenterId$().bNs())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$Shown($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_Show$Shown$().aH(this.XH, $j_app$002edata$002e$002dApp$002dDocument$002dStorage$002dFormat$0024.$m_Lapp_data_AppDocumentStorageFormat$().bNr())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$Shown($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_Show$Shown$().aH(this.XG, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_Base64Id$().WM()))])));
    this.ayX = true;
  }
  return this.ayW;
});
function $isArrayOf_Lapp_data_AppDocumentId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j3)));
}
export { $isArrayOf_Lapp_data_AppDocumentId as $isArrayOf_Lapp_data_AppDocumentId };
var $d_Lapp_data_AppDocumentId = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentId, "app.data.AppDocumentId", ({
  j3: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentId as $d_Lapp_data_AppDocumentId };
//# sourceMappingURL=app.data.-App-Document-Id.js.map
